module.exports = __webpack_public_path__ + "static/pinkmummyme3-fbedfd63d2bbfb458baf50969a8baf6c.png";